{
	"language": {
		"aria": "Keisti kalbą"
	},
	"placeholder": {
		"title": "Jūsų kandidato centras jau ruošiamas",
		"body": "Kol kas čia nieko nėra. Kai viskas bus paruošta, atsiųsime jums nuorodą el. paštu."
	},
	"not_found": {
		"title": "Puslapis nerastas",
		"body": "Patikrinkite nuorodą, kuria atėjote, arba naudokite nuorodą iš savo el. laiško."
	},
	"error_boundary": {
		"reload": "Įkelti puslapį iš naujo"
	},
	"login": {
		"loading": "Įkeliama…",
		"title": "Prisijunkite prie savo kandidato centro",
		"intro": "Įveskite savo el. pašto adresą, kad matytumėte savo paraiškas.",
		"email_label": "El. pašto adresas",
		"email_placeholder": "jus@pavyzdys.lt",
		"submit": "Prisijungti",
		"sending": "Siunčiama…",
		"sent": {
			"title": "Patikrinkite savo el. paštą",
			"body": "Jei {{email}} atitinka paraišką, prisijungimo nuoroda jau pakeliui.",
			"retry": "Negavote? Patikrinkite adresą ir bandykite dar kartą"
		},
		"resent": {
			"title": "Išsiuntėme jums naują prisijungimo nuorodą",
			"body": "Jūsų atidarytos nuorodos galiojimas baigėsi. Jei jūsų el. paštas atitinka paraišką, nauja prisijungimo nuoroda jau pakeliui. Ji atidarys tą patį puslapį.",
			"request_manually": "Negavote? Paprašykite naujos nuorodos"
		},
		"request_error": {
			"throttled": "Per daug bandymų. Palaukite minutę ir bandykite dar kartą.",
			"invalid_email": "Įveskite galiojantį el. pašto adresą.",
			"generic": "Kažkas nepavyko. Bandykite dar kartą."
		},
		"unknown_organisation": {
			"title": "Puslapis nerastas",
			"body": "Patikrinkite nuorodą, kuria atėjote, arba naudokite nuorodą iš savo el. laiško."
		},
		"error": {
			"title": "Kažkas nepavyko",
			"body": "Nepavyko įkelti šio puslapio. Bandykite dar kartą po akimirkos."
		}
	},
	"organisations": {
		"title": "Jūsų paraiškos",
		"intro": "Pasirinkite įmonę, kad matytumėte jai išsiųstas paraiškas.",
		"count_one": "{{count}} paraiška",
		"count_few": "{{count}} paraiškos",
		"count_other": "{{count}} paraiškų",
		"empty": {
			"title": "Kol kas paraiškų nėra",
			"body": "Kai pateiksite paraišką įmonei, ji bus rodoma čia."
		},
		"error": "Nepavyko įkelti jūsų įmonių. Bandykite dar kartą po akimirkos.",
		"log_out": "Atsijungti",
		"logging_out": "Atsijungiama…"
	},
	"submissions": {
		"title": "Ankstesnės paraiškos",
		"back_to_organisations": "Visos įmonės",
		"cv_uploaded": "CV įkeltas",
		"empty": {
			"title": "Kol kas paraiškų nėra",
			"body": "Paraiškos, kurias išsiųsite įmonei {{organisation}}, bus rodomos čia."
		},
		"error": "Nepavyko įkelti jūsų paraiškų. Bandykite dar kartą po akimirkos.",
		"log_out": "Atsijungti",
		"logging_out": "Atsijungiama…"
	},
	"profile": {
		"link": {
			"title": "Jūsų profilis",
			"cv_added": "CV pridėtas",
			"cv_missing": "CV dar nėra"
		},
		"back": "Atgal į paraišką",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Sutinkate, kad su jumis būtų susisiekta dėl šio darbo.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Įkelkite savo CV",
				"drop_hint": "arba nuvilkite jį čia",
				"constraints": "{{types}}, iki {{size}} MB",
				"uploading": "Įkeliamas {{fileName}}…",
				"done": "CV įkeltas",
				"error_type": "Šis failo tipas nepalaikomas. Leidžiami tipai: {{types}}.",
				"error_size": "Failas per didelis. Didžiausias dydis – {{size}} MB."
			},
			"remove": {
				"label": "Pašalinti {{fileName}}",
				"question": "Pašalinti {{fileName}}?",
				"consequence": "Darbdavys jo nebematys. Šio veiksmo atšaukti negalima.",
				"confirm": "Pašalinti CV",
				"cancel": "Atšaukti",
				"removing": "Šalinama…",
				"error": "Nepavyko pašalinti jūsų CV. Bandykite dar kartą."
			}
		},
		"work_history": {
			"title": "Darbo patirtis",
			"description": "Papasakokite mums apie savo aktualią darbo patirtį: kur dirbote, ką ten veikėte ir kiek laiko ten dirbote. Galite nurodyti daugiau nei vieną darbą, jei jie aktualūs.",
			"placeholder": "Aprašykite darbą, kurį dirbote",
			"input_label": "Darbo informacija",
			"save": "Išsaugoti",
			"saving": "Išsaugoma…",
			"cancel": "Atšaukti",
			"edit": "Redaguoti",
			"remove": "Pašalinti",
			"add_another": "Pridėti dar vieną darbą",
			"error_empty": "Prieš išsaugodami ką nors parašykite.",
			"error_limit": "Galite pridėti iki {{max}} darbų.",
			"unsaved_changes": "Turite neišsaugotų darbo patirties pakeitimų. Ar vis tiek norite išeiti ir juos prarasti?",
			"hints": {
				"label": "Šio darbo informacija",
				"included": "nurodyta",
				"missing": "dar nenurodyta"
			}
		},
		"education": {
			"title": "Išsilavinimas",
			"description": "Papasakokite mums apie savo aktualų išsilavinimą: ką studijavote, kur ir kada. Tinka laipsniai, mokyklos, kursai ir sertifikatai. Galite nurodyti daugiau nei vieną.",
			"placeholder": "Aprašykite laipsnį, mokyklą ar kursą",
			"input_label": "Išsilavinimo informacija",
			"save": "Išsaugoti",
			"saving": "Išsaugoma…",
			"cancel": "Atšaukti",
			"edit": "Redaguoti",
			"remove": "Pašalinti",
			"add_another": "Pridėti dar vieną išsilavinimą",
			"error_empty": "Prieš išsaugodami ką nors parašykite.",
			"error_limit": "Galite pridėti iki {{max}} išsilavinimo įrašų.",
			"unsaved_changes": "Turite neišsaugotų išsilavinimo pakeitimų. Ar vis tiek norite išeiti ir juos prarasti?"
		},
		"licenses": {
			"title": "Pažymėjimai ir sertifikatai",
			"description": "Papasakokite mums apie turimus pažymėjimus ir sertifikatus, pavyzdžiui, vairuotojo pažymėjimą, krautuvo vairuotojo pažymėjimą ar higienos pažymėjimą. Nurodykite, kada jį gavote ir kada baigiasi jo galiojimas, jei taikoma. Galite nurodyti daugiau nei vieną.",
			"placeholder": "Aprašykite pažymėjimą ar sertifikatą",
			"input_label": "Pažymėjimo informacija",
			"save": "Išsaugoti",
			"saving": "Išsaugoma…",
			"cancel": "Atšaukti",
			"edit": "Redaguoti",
			"remove": "Pašalinti",
			"add_another": "Pridėti dar vieną pažymėjimą",
			"error_empty": "Prieš išsaugodami ką nors parašykite.",
			"error_limit": "Galite pridėti iki {{max}} pažymėjimų.",
			"unsaved_changes": "Turite neišsaugotų pažymėjimų pakeitimų. Ar vis tiek norite išeiti ir juos prarasti?"
		}
	},
	"submission": {
		"back": "Atgal į mano paraiškas",
		"back_short": "Atgal",
		"not_found": {
			"title": "Paraiška nerasta",
			"body": "Šios paraiškos nėra arba ji nėra jūsų."
		},
		"result": {
			"heading": "Patvirtinimo langas, kurį matėte pateikę paraišką"
		},
		"summary": {
			"title": "Jūsų atsakymų santrauka",
			"submitted_on": "Šią formą pateikėte",
			"submitted_more_than_once": "Šią formą užpildėte daugiau nei vieną kartą. Jūsų profilį sujungsime automatiškai; žemiau pateikta paraiška yra naujausia."
		}
	}
}
